import moduleCapacity from "@/store/capacity/moduleCapacity.js";
import moduleSkills from "@/store/skills/moduleSkills.js";
import moduleTeams from "@/store/teams/moduleTeams.js";
import moduleBreaks from "@/store/breaks/moduleBreaks.js";
import Vehicle from "@/models/Vehicle";
import depositInit from "@/assets/images/markers/deposit/office-building-8-green.png";
import depositEnd from "@/assets/images/markers/deposit/finish-flag.png";
import streetviewImg from "@/assets/images/maps/google-street-view-icon-5.png";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import GoogleMap from "@/components/Maps/Maps.vue";
import AssignedSkillList from "@/components/skills/AssignedSkillList.vue";
import AssignedCapacityList from "@/components/capacity/AssignedCapacityList.vue";
import AssignedTeamsList from "@/components/teams/AssignedTeamsList.vue";
import AssignedBreakList from "@/components/break/list/AssignedBreakList.vue";
import AssignedFrequencyList from "@/components/frequency/list/AssignedFrequencyList.vue";
import DepotList from "@/components/depot/DepotList.vue";
import moduleMap from "@/store/map/moduleMap.js";
import FloatingButtons from "@/views/FloatingButtons.vue";

export const vehicleMixin = {
	name: "VehicleCreate",
	components: {
		vSelect,
		flatPickr,
		GoogleMap,
		AssignedSkillList,
		AssignedCapacityList,
		AssignedTeamsList,
		AssignedBreakList,
		DepotList,
		AssignedFrequencyList,
		FloatingButtons,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
		showButtonCancel: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			showMap: false,
			activePrompt: false,
			vehicle: new Vehicle({}),
			activeTab: 0,
			columnsCapacity: ["name", "description", "action"],
			defaultColumnsCapacity: ["name", "description"],
			hours: 0,
			minutes: 0,
			seconds: 0,
			showPromptField: false,
			propertiesList: [],
			propertiesObject: {},
			isUpdate: false,
			indexUpdate: null,
			depotMounted: false,
			isDepotInit: false,
			isDepotEnd: false,
			markersDeposit: [],
			dangerInput: {
				identification: {show: false, text: ""},
				cy: {show: false, text: ""},
				cx: {show: false, text: ""},
			},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			skillListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: ["id", "name", "description", "identifier", "action"],
				defaultColumns: ["id", "name", "description", "identifier"],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
				navbarOptions: true,
			},
			teamListConfig: {
				columns: ["id", "name", "description", "action"],
				defaultColumns: ["id", "name", "description", "action"],
				actionDropdown: false,
				btnAssig: true,
				navbarOptions: true,
				multiple: true,
			},
			depotListConfig: {
				btnAdd: false,
				showColumns: {
					id: true,
					name: true,
					description: false,
					address: true,
					city: true,
					action: false,
				},
				multiple: false,
			},
			property: {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			},
			type: [
				{
					label: "Text",
					value: "text",
				},
				{
					label: "Date",
					value: "date",
				},
				{
					label: "Time",
					value: "time",
				},
				{
					label: "Number",
					value: "number",
				},
			],
			profileOptions: [
				{
					label: this.$t("Routing.Car"),
					value: "car",
				},
				{
					label: this.$t("Routing.Walking"),
					value: "walk",
				},
				{
					label: this.$t("Routing.Bicycle"),
					value: "bicycle",
				},
				{
					label: this.$t("Routing.Motorcycle"),
					value: "motorcycle",
				},
				{
					label: this.$t("Routing.Truck"),
					value: "truck",
				},
				{
					label: this.$t("Routing.Scooter"),
					value: "scooter",
				},
				{
					label: this.$t("Routing.Bus"),
					value: "bus",
				},
			],
		};
	},
	computed: {
		validateForm() {
			return !this.errors.any();
		},
		validFormAdditionalFields() {
			return this.property.label.length > 0 && this.property.value.length > 0;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		generateOptionSelect(data, propLabel, propValue) {
			if (!Array.isArray(data)) {
				return [];
			}
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		save_changes() {
			if (!this.validateForm) return;
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (!this.validateForm) return;
					this.registerVehicle();
				} else {
					this.$vs.notify({
						color: "danger",
						title: this.$t("VisitPoints.ValidData.Title"),
						text: this.$t("VisitPoints.ValidData.Text"),
						time: 6000,
					});
					this.activeTab = 0;
				}
			});
		},
		registerVehicle() {
			delete this.vehicle.id;
			this.vehicle["max_travel_distance"] = parseInt(this.vehicle.max_travel_distance) || null;
			this.vehicle["init_depot_id"] = this.$store.state.vehicle.depotInfoInit
				? parseInt(this.$store.state.vehicle.depotInfoInit.id)
				: null;
			this.vehicle["end_depot_id"] = this.$store.state.vehicle.depotInfoEnd
				? parseInt(this.$store.state.vehicle.depotInfoEnd.id)
				: null;
			this.vehicle["costs"] = {
				time: parseFloat(this.vehicle.costs.time),
				traveled_hour: parseFloat(this.vehicle.costs.traveled_hour),
				distance: parseFloat(this.vehicle.costs.distance),
				fixed: parseFloat(this.vehicle.costs.fixed),
			} || {time: 0, traveled_hour: 0, distance: 0, fixed: 0};
			this.vehicle["skills_id"] = this.$store.state.moduleSkills.listSelectedSkills.map(({id}) => id) || [];
			this.vehicle["teams_id"] = this.$store.state.moduleTeams.assignedTeams.map(({id}) => id) || [];
			this.vehicle["breaks_id"] = this.$store.state.moduleBreaks.assignedBreaks.map(({id}) => id) || [];
			this.vehicle["repeat_frequency_id"] =
				this.$store.state.frequency.assignedFrequencies.map(({id}) => id) || [];
			this.vehicle["profile"] = this.vehicle.profile.value || "car";
			this.vehicle["additional_info"] = this.propertiesObject || {};
			this.vehicle["json_properties"] = this.propertiesList || [];
			this.vehicle["max_travel_duration"] = `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
			this.vehicle["capacities"] = this.$store.state.moduleCapacity.listSelectedCapacities.map((capacity) => ({
				capacity_id: capacity.id,
				amount: parseInt(capacity.demand),
			}));
			this.$store
				.dispatch("vehicle/save", this.vehicle)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Vehicles.Success.Title"),
						text: this.$t("Vehicles.Success.Text"),
					});
					this.vehicle = new Vehicle({});
					this.$router.push({name: "app-vehicle-list"});
				})
				.catch((error) => {
					console.warn(error);
					this.validateErrorRegister(error.data);
				});
		},
		validateErrorRegister(error) {
			if (error === null || error === undefined) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: this.$t("VisitPoints.ErrorRegisterValidate.Text"),
				});
				return;
			}
			if (error.error.length > 0) {
				if (error.error[0].absolute_path[0] === "identification") {
					this.$vs.notify({
						color: "danger",
						title: this.$t("VisitPoints.ValidData.Title"),
						text: this.$t("ManualData.identification") + ": " + this.$t("ManualData.AlreadyRegistered"),
						time: 7000,
					});
				}
			}
		},
		addProperty(property) {
			let findOther = this.propertiesList.findIndex((elem) => elem.label === property.label);
			if (findOther == -1) {
				this.propertiesList.push(property);
				this.propertiesObject[property.label] = property.value;
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdate) {
				this.updateProperty(property);
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
				});
			}
		},
		deleteItem(data, indexItem) {
			this.propertiesList.splice(indexItem, 1);
			delete this.propertiesObject[data.label];
		},
		editSelect(val, index) {
			this.isUpdate = true;
			this.showPromptField = true;
			this.property.label = val.label;
			this.property.value = val.value;
			this.property.type = val.type;
			this.indexUpdate = index;
		},
		updateProperty(property) {
			this.propertiesList[this.indexUpdate].label = property.label;
			this.propertiesList[this.indexUpdate].value = property.value;
			this.propertiesList[this.indexUpdate].type = property.type;
			this.propertiesObject[property.label] = property.value;
		},
		showPrompt() {
			this.showPromptField = true;
			this.isUpdate = false;
			this.property = {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			};
		},
		validateKeyAdditionalInfo(event) {
			let regex = /^[a-zA-Z_]\w*$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateAmountNumber(event) {
			let regex = /^\d+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumber(event) {
			if (this.hours.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberMinutes(event) {
			if (this.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberSeconds(event) {
			if (this.seconds.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateDateHours() {
			if (this.hours === "" || this.hours === null) this.hours = 0;
		},
		validateDateMinutes() {
			if (this.minutes === "" || this.minutes === null) this.minutes = 0;
		},
		validateDateSecond() {
			if (this.seconds === "" || this.seconds === null) this.seconds = 0;
		},
		depotSelected(depot) {
			if (depot.cy === "0" && depot.cx === "0") {
				this.$vs.notify(this.getDepotNotification());
				return;
			}
			if (this.isDepotInit) {
				this.handleDepotSelection(depot, "DepositInit");
			}
			if (this.isDepotEnd) {
				this.handleDepotSelection(depot, "DepositEnd");
			}
			Anuket.fitBoundsMarkerGroup(this.markersDeposit);
			this.depotMounted = false;
		},
		handleDepotSelection(depot, type) {
			const storeKey = type === "DepositInit" ? "deposit_Init" : "deposit_End";
			const vehicleKey = type === "DepositInit" ? "init_depot_id" : "end_depot_id";
			const markerType = type;
			this.removeExistingMarker(markerType);
			depot.type = markerType;
			this.$store.commit("vehicle/SET_" + storeKey.toUpperCase(), depot);
			this.vehicle[vehicleKey] = depot.id + "-" + depot.name;
			this.markersDeposit.push(
				this.addMarkerDeposit(depot, type === "DepositInit" ? depositInit : depositEnd, false)
			);
		},
		removeExistingMarker(markerType) {
			const storeKey = markerType === "DepositInit" ? "depotInfoInit" : "depotInfoEnd";
			if (this.markersDeposit.length > 0 && this.$store.state.vehicle[storeKey] !== null) {
				for (let item of this.markersDeposit) {
					if (
						item.details.id === this.$store.state.vehicle[storeKey].id &&
						item.details.type === markerType
					) {
						item.setMap(null);
					}
				}
			}
		},
		getDepotNotification() {
			return {
				color: "warning",
				title: this.$t("VisitPoints.ErrorFindAddress.Title"),
				text: this.$t("VisitPoints.ErrorFindAddress.Text"),
			};
		},
		showPopupDepositInit() {
			this.isDepotEnd = false;
			this.depotMounted = true;
			this.isDepotInit = true;
		},
		showPopupDepositEnd() {
			this.isDepotInit = false;
			this.depotMounted = true;
			this.isDepotEnd = true;
		},
		removeDepositInit() {
			if (this.markersDeposit.length > 0 && this.$store.state.vehicle.depotInfoInit !== null) {
				for (let item of this.markersDeposit) {
					if (
						item.details.id === this.$store.state.vehicle.depotInfoInit.id &&
						item.details.type === "DepositInit"
					) {
						item.setMap(null);
					}
				}
			}
			this.vehicle.init_depot_id = null;
		},
		removeDepositEnd() {
			if (this.markersDeposit.length > 0 && this.$store.state.vehicle.depotInfoEnd !== null) {
				for (let item of this.markersDeposit) {
					if (
						item.details.id === this.$store.state.vehicle.depotInfoEnd.id &&
						item.details.type === "DepositEnd"
					) {
						item.setMap(null);
					}
				}
			}
			this.vehicle.end_depot_id = null;
		},
		addMarkerDeposit(deposit, icon = depositInit, draggable = false) {
			const lat = deposit.cy;
			const lng = deposit.cx;
			let title = deposit.id ? deposit.id + "" : " ";
			let content = this.generateInfowindowContentDeposit(deposit);
			// Opciones
			let options = {
				data: deposit.id || 0,
				drag: draggable,
				icon,
				title,
				info: deposit.vehicleLabel || deposit,
				infoWindow: {
					content,
				},
				onClose: () => {
					this.instanceInfo.$destroy();
				},
			};
			const marker = Anuket.addMarker({lat, lng}, options);
			Anuket.centerMap(lat, lng, {zoom: 18});
			return marker;
		},
		generateInfowindowContentDeposit({address, city, country, cx, cy, id, name}) {
			let $docFragment = document.createDocumentFragment();
			let $infowindowDivContent = document.createElement("div");
			$infowindowDivContent.style.cssText = "text-align: justify";
			let $title = document.createElement("h4");
			let $subtitle = document.createElement("h4");
			$title.textContent = name;
			$subtitle.textContent = `${this.$t("Routing.Map.VisitPoints.Identifier")}: ${name === null ? "-" : name} `;
			let $name = document.createElement("p");
			let $deposit = document.createElement("p");
			let $address = document.createElement("p");
			let $avatar = document.createElement("img");
			$avatar.setAttribute("src", streetviewImg);
			$avatar.setAttribute("alt", "StreetView");
			$avatar.setAttribute("title", "StreetView");
			$avatar.className = "h-8 w-8 mr-1 cursor-pointer streetview-maps-module";
			$name.innerHTML = `<strong>${"Id"}:</strong> ${id}`;
			$deposit.innerHTML = `<strong>${this.$t("City")}</strong>: ${city}`;
			$address.innerHTML = `<strong>${this.$t("Address")}</strong>: ${address}`;
			$docFragment.appendChild($title);
			$docFragment.appendChild($name);
			$docFragment.appendChild($deposit);
			$docFragment.appendChild($address);
			$docFragment.appendChild($avatar);
			$infowindowDivContent.appendChild($docFragment);
			return $infowindowDivContent;
		},
	},
	watch: {
		activeTab(val) {
			if (val === 0) {
				this.markersDeposit = [];
				if (this.$store.state.vehicle.depotInfoInit != null) {
					setTimeout(() => {
						if (
							this.$store.state.vehicle.depotInfoInit.cx !== 0 &&
							this.$store.state.vehicle.depotInfoInit.cy !== 0
						)
							this.markersDeposit.push(
								this.addMarkerDeposit(this.$store.state.vehicle.depotInfoInit, depositInit, false)
							);
					}, 1000);
				}
				if (this.$store.state.vehicle.depotInfoEnd != null) {
					setTimeout(() => {
						if (
							this.$store.state.vehicle.depotInfoEnd.cx !== 0 &&
							this.$store.state.vehicle.depotInfoEnd.cy !== 0
						)
							this.markersDeposit.push(
								this.addMarkerDeposit(this.$store.state.vehicle.depotInfoEnd, depositEnd, false)
							);
					}, 1000);
				}
				setTimeout(() => {
					Anuket.fitBoundsMarkerGroup(this.markersDeposit);
				}, 1000);
			}
		},
		hours(val) {
			if (val > 23) {
				this.hours = 23;
			}
		},
		minutes(val) {
			if (val > 59) {
				this.minutes = 59;
			}
		},
		seconds(val) {
			if (val > 59) {
				this.seconds = 59;
			}
		},
	},
	created() {
		if (!moduleCapacity.isRegistered) {
			this.$store.registerModule("moduleCapacity", moduleCapacity);
			moduleCapacity.isRegistered = true;
		}
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
		if (!moduleTeams.isRegistered) {
			this.$store.registerModule("moduleTeams", moduleTeams);
			moduleTeams.isRegistered = true;
		}
		if (!moduleBreaks.isRegistered) {
			this.$store.registerModule("moduleBreaks", moduleBreaks);
			moduleBreaks.isRegistered = true;
		}
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
	},
	mounted() {
		this.showMap = true;
	},
	beforeDestroy() {
		this.$store.commit("moduleCapacity/REMOVE_ALL_ASSIGNED_CAPACITY");
		this.$store.commit("moduleSkills/REMOVE_ALL_ASSIGNED_SKILL");
		this.$store.commit("moduleTeams/CLEAN_ASSIGNED_TEAMS");
		this.$store.commit("moduleBreaks/CLEAN_ASSIGNED_BREAKS");
		this.$store.commit("vehicle/SET_DEPOSIT_INIT", null);
		this.$store.commit("vehicle/SET_DEPOSIT_END", null);
		this.$store.commit("frequency/REMOVE_ALL_ASSIGNED_FREQUENCY");
	},
};
